<section fxFlex fxLayout="column" fxLayoutAlign="center center">
    <forge-card *ngIf="authenticatingTid">
        <div fxLayout="column" fxLayoutAlign="center center">
            <forge-circular-progress diameter="diameter" stroke-width="stroke"></forge-circular-progress>
            <span class="forge-typography--body2 busy-message">Authenticating...</span>
        </div>
    </forge-card>


    <div *ngIf="!hidden" fxLayout="column" class="loginBox">
        <forge-card fxLayout="column">
            <div fxLayout="column" fxLayoutAlign="start stretch">
                <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
                    <img src="/library/tylerui/images/tyler_logo.jpg" alt="Tyler Technologies">
                    <h1 class="forge-typography--heading7" style="margin: 0; color: var(--forge-theme-brand);">{{productText}}</h1>
                </div>

                <div fxLayout="column" fxLayoutAlign="space-around center" class="tt-margin--top tt-margin--bottom">
                    <div class="forge-typography--heading1">
                        {{SubHeader}}
                    </div>
                </div>

                <div *ngIf="useTylerId && !IsMigrateTidUser" fxLayout="column" fxLayoutAlign="center center">
                    <div *ngIf="!error; else tylerIdError" fxLayout="column" fxLayoutAlign="center center">
                        <div>Authenticating with Tyler Identity</div>
                        <forge-circular-progress diameter="diameter" stroke-width="stroke"></forge-circular-progress>
                    </div>
                </div>

                <ng-container *ngIf="!busy">
                    <login-form *ngIf="IsLogin" [formType]="formType" [isDisabled]="isDisabled"
                                [showForgotPwLink]="showForgotPwLink" [showRememberMe]="showRememberMe"
                                (goto)="onGoto($event)">
                    </login-form>

                    <signout-form *ngIf="IsSignout">
                    </signout-form>

                    <migrate-tid-form *ngIf="IsMigrateTidUser" [isDisabled]="isDisabled" (goto)="onGoto($event)">
                    </migrate-tid-form>

                    <forgot-password-form *ngIf="IsForgotPassword" (goto)="onGoto($event)">
                    </forgot-password-form>

                    <change-password-form *ngIf="IsChangePassword" (goto)="onGoto($event)">
                    </change-password-form>

                    <reset-password-form *ngIf="IsResetPassword">
                    </reset-password-form>
                </ng-container>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" class="margin-8">
                <div *ngIf="version">{{version}}</div>
                <div>{{tenant}}</div>
            </div>

        </forge-card>
    </div>
</section>

<ng-template #tylerIdError>
    <div class="error-text">
        Invalid username or password
    </div>
</ng-template>
